import * as React from 'react';
import '../Styles/CutPaste.css';

export default function CutPasteURL({ap}) {
    const [textCopied, setTextCopied] = React.useState<boolean>(false);
  return (
    <div className="container w-100" style={{
        paddingTop: "15%"
    }}>
        <div className="d-flex flex-column">
            <div className="Title">
                <h3 style={{
                    fontWeight: 600
                }}>WaveMax</h3>
            </div>
            <div className="Logo">
                <img width="100%" src="/jpeg/graficowifi.png" alt=""/>
            </div>
            <div className="Description">
                Disfruta de acceso a internet gratis.
            </div>
            <div className="CutInput">
                <div className="input_copy">
                    <span className="txt">{window.location.href.split("?")[0]}</span>
                    <span className="icon right" onClick={() => {
                        navigator.clipboard.writeText(window.location.href + "&usingbrowser=true");
                        setTextCopied(true);
                        setTimeout(() => {
                            setTextCopied(false);
                        }, 2000)

                    }}>
                        <img src="/jpeg/copy-4.png" 
                            title="Click to Copy"
                        />
                    </span>
                </div>
            
            </div>
            <div className="FooterDesc">
                Haz click en copear y pega la url en tu navegador para comenzar.
            </div>

            {
                textCopied && (
                    <div className="TextCopied">
                        <div>
                            <span>Copiado</span>
                        </div>
                    </div>
                )
            }
            
        </div>
    </div>
  )
}
